<template>
  <router-link :to="{ path: '/knowledge', query: { a: article } }" class="kb-hint" :title="text || 'Как это работает'">
    <span class="kb-hint__dot" aria-hidden="true">?</span>
    <span v-if="label" class="kb-hint__label">{{ label }}</span>
  </router-link>
</template>

<script>
// Неназойливая подсказка: «?» рядом с полем или блоком, ведёт в статью Базы знаний.
export default {
  name: 'KbHint',
  props: {
    article: { type: String, required: true },
    text: { type: String, default: '' },
    label: { type: String, default: '' },
  },
}
</script>

<style scoped>
.kb-hint { display: inline-flex; align-items: center; gap: 4px; color: #8a7a3d; text-decoration: none;
  font-size: 12px; vertical-align: middle; }
.kb-hint__dot { width: 16px; height: 16px; border-radius: 50%; display: grid; place-items: center; font-size: 10px;
  font-weight: 700; color: #6b5a12; background: #fff3d1; border: 1px solid #f2d27a; transition: transform .2s, background .2s; }
.kb-hint:hover .kb-hint__dot { transform: scale(1.15); background: #f2b705; color: #1f2430; }
.kb-hint__label { text-decoration: underline dotted; text-underline-offset: 2px; }
</style>
